/**
 * Azure AD B2C Error Codes
 * @see https://docs.microsoft.com/en-us/azure/active-directory-b2c/error-codes
 */
export const B2C_ERROR_CODES = {
  /**
   * AADB2C90091: User cancellation
   * This occurs when the user cancels a password change, self-asserted flow,
   * or other user flow operation in Azure AD B2C
   */
  USER_CANCELLED: 'AADB2C90091'
} as const;

/**
 * Helper function to check if an error message includes a specific B2C error code
 */
export function isB2CError(errorMessage: string | undefined, errorCode: string): boolean {
  return errorMessage?.includes(errorCode) ?? false;
}
